/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@paypalcorp/pp-react';
import CallUsInfo from '../../../components/callUsComponent/CallUsInfo';
import { FPTI_DATA } from '../../../common/propTypes';

// TODO :  Can we fire the fpti in the components rather than here ? Make a call and pass it upstream.
const CallUsInfoPanel = function (props) {
  const { pageName, FPTIData } = props;

  return (
    <Container>
      <CallUsInfo pageName={pageName} FPTIData={FPTIData} />
    </Container>
  );
};

CallUsInfoPanel.propTypes = {
  pageName: PropTypes.string.isRequired,
  FPTIData: PropTypes.shape(FPTI_DATA).isRequired,
};
export default CallUsInfoPanel;
